module.exports = __webpack_public_path__ + "ismv-static/media/location.44004bb5.jpg";